import React from "react";

const JumboThemeHeaderContext = React.createContext();

export default JumboThemeHeaderContext;